import { apiRequest } from './client.js';

/**
 * One job as Job Tracking reports it — the same shape the server sends, so
 * nothing is mapped on the way in.
 */
export interface TrackedJob {
  readonly jobRequestId: string;
  readonly jobNumber: string | null;
  readonly customerName: string;
  readonly dealerCode: string | null;
  readonly district: string | null;
  readonly requestDate: string;
  readonly areaRequested: string;
  readonly areaUnit: string;
  readonly currentStatus: string;
  readonly workflowInstanceId: string | null;
  readonly instanceStatus: string | null;
  /** The stage it is standing at now. Null when nothing is pending. */
  readonly pendingStepName: string | null;
  readonly pendingStepSequence: number | null;
  readonly pendingRoleCode: string | null;
  readonly pendingUserName: string | null;
  readonly waitingSince: string | null;
  /**
   * Whole minutes, measured by the database's own clock — never recomputed
   * here. See `backend/src/common/elapsed.ts` for why the browser must not.
   */
  readonly waitingMinutes: number | null;
  readonly brandingRequestNo: string | null;
  readonly vendorName: string | null;
  /** Every reason this job is mine, not just the first one found. */
  readonly mineAs: readonly string[];
}

type Tok = string | null | undefined;

/** Every job that is mine, wherever it has got to. */
export const loadMyTrackedJobs = (token?: Tok) =>
  apiRequest<{ data: readonly TrackedJob[] }>('/v1/job-tracking/mine', {
    token,
  });
